import { Epic } from 'redux-observable';
import { of, from } from 'rxjs';
import { mergeMap, map, catchError, filter } from 'rxjs/operators';
import { RootState } from '../store';
import { fetchPropensityHierarchyBreakdown } from '@/services/api';
import {
  FETCH_PROPENSITY_HIERARCHY_REQUESTED,
  fetchPropensityHierarchySucceeded,
  fetchPropensityHierarchyFailed,
  setPropensityHierarchyLoading,
  setPropensityHierarchyError,
  setPropensityHierarchyNode
} from '../slices/propensityHierarchySlice';

export const fetchPropensityHierarchyEpic: Epic<any, any, RootState> = (action$) =>
  action$.pipe(
    filter((action: any) => action.type === FETCH_PROPENSITY_HIERARCHY_REQUESTED),
    mergeMap((action: any) => {
      const { target_employee_id, target_role, hierarchy_path } = action.payload || {};
      return from(fetchPropensityHierarchyBreakdown({ target_employee_id, target_role, hierarchy_path })).pipe(
        map((response) => fetchPropensityHierarchySucceeded(response)),
        catchError((error) => of(fetchPropensityHierarchyFailed(error.message || 'Failed to fetch propensity hierarchy')))
      );
    })
  );

export const handlePropensityHierarchySuccessEpic: Epic<any, any, RootState> = (action$) =>
  action$.pipe(
    filter((action: any) => action.type === 'propensityHierarchy/FETCH_SUCCEEDED'),
    mergeMap((action: any) => {
      return of(
        setPropensityHierarchyNode(action.payload),
        setPropensityHierarchyLoading(false),
        setPropensityHierarchyError(null)
      );
    })
  );

export const handlePropensityHierarchyFailureEpic: Epic<any, any, RootState> = (action$) =>
  action$.pipe(
    filter((action: any) => action.type === 'propensityHierarchy/FETCH_FAILED'),
    mergeMap((action: any) => {
      return of(
        setPropensityHierarchyError(action.payload),
        setPropensityHierarchyLoading(false)
      );
    })
  );

export const propensityHierarchyEpics = [
  fetchPropensityHierarchyEpic,
  handlePropensityHierarchySuccessEpic,
  handlePropensityHierarchyFailureEpic
];

export default propensityHierarchyEpics;


